export default {
    TRIAL: "TRIAL",
    BASIC: "BASIC",
    PRO: "PRO"
};
